import styled, { css } from "styled-components";

export const Container = styled.div`
  padding: 20px;
  background-color: white;
  border-radius: 4px;
  margin-bottom: 24px;

  @media only screen and (max-width: 768px) {
    padding: 10px;
  }
`;

export const StyledBackButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0;
  color: var(--text);
  line-height: 1.5em;
  &:disabled {
    opacity: 0.65;
  }
  &:before {
    content: "";
    display: inline-block;
    margin-right: 10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 10px 5px 0;
    border-color: transparent var(--accent) transparent transparent;
  }
`;

export const StepTitle = styled.p<{ isGrayed: boolean }>`
  margin: 14px 0 18px;
  font-size: 22px;
  color: var(--color-black);
  font-family: "Inter", sans-serif;
  font-weight: 600;

  ${({ isGrayed }) =>
    isGrayed &&
    css`
      opacity: 0.4;
    `}

  @media only screen and (max-width: 768px) {
    margin: 11px 0 18px;
    font-size: 18px;
  }
`;

export const IndicatorRoot = styled.div<{ width: string }>`
  width: 100%;
  height: 40px;
  background: #f4f4f4 0 0 no-repeat padding-box;
  box-shadow: inset 0 3px 10px #00000043;
  border-radius: 10px;
  &:before {
    content: "";
    display: block;
    width: ${(props) => props.width};
    height: 40px;
    background: var(--progress-bar-color) 0 0 no-repeat padding-box;
    border-radius: 10px;
  }
`;
